module.exports = __webpack_public_path__ + "static/img/image 3.41b88cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xh/images/image 3.png
// module id = PbUv
// module chunks = 8